<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col>
      <v-card>
        <v-app-bar dark color="accent">
          <v-icon class="mr-3">mdi-file-document-edit</v-icon>
          <v-toolbar-title>Please fill up the following information to register customers.</v-toolbar-title>
        </v-app-bar>
        <v-container fluid>
          <v-row style="margin-top: 20px">
            <v-col cols="12" md="4"/>
            <v-col cols="12" md="4">
              <ValidationObserver v-slot="{ passes, validate, reset}">
              <form>
                <span>Full Name (as per NRIC)</span>
                <ValidationProvider name="Full Name (as per NRIC)" :rules="{ required, max:80, regex: /^[A-Za-z\s@'/.-]+$/ }" v-slot="{errors, failedRules}">
                  <v-text-field v-model="name"
                                label="Full Name (as per NRIC)"
                                :error-messages="$translatedErrorMessages(failedRules,'Full Name (as per NRIC)')"
                                placeholder="Please enter customer's full name as indicated on NRIC" solo flat outlined/>
                </ValidationProvider>

                <span>Identification Number (ID)</span>
                <ValidationProvider name="Identification Number (ID)" rules="required|alpha_num" v-slot="{ errors, failedRules }">
                  <v-text-field v-model="id"
                                label="Identification Number (ID)"
                                :error-messages="$translatedErrorMessages(failedRules,'Identification Number (ID)')"
                                placeholder="Please enter customer's NRIC/passport number" solo flat outlined/>
                </ValidationProvider>

                <span>Business Registration (BR) No.</span>
                <ValidationProvider name="Business Registration (BR) No." :rules="{ required, max:80, regex: /^[A-Za-z\s@'/.-]+$/ }" v-slot="{errors, failedRules}">
                  <v-text-field v-model="name"
                                label="Full Name (as per NRIC)"
                                :error-messages="$translatedErrorMessages(failedRules,'business_registration_number')"
                                placeholder="Please enter company's BR number" solo flat outlined/>
                </ValidationProvider>

                <span>Ethnicity</span>
                <ValidationProvider name="CGC Branch" rules="required" v-slot="{ errors, failedRules }">
                  <v-select v-model="branch"
                            :items="data.ethinicity"
                            label="Please select ethinicity"
                            :error-messages="$translatedErrorMessages(failedRules,'Ethnicity')"
                            solo/>
                </ValidationProvider>

                <span>Company Name</span>
                <ValidationProvider name="Company Name" :rules="{ required, max:80, regex: /^[A-Za-z0-9_.&()'\s-]+$/ }" v-slot="{ errors, failedRules }">
                  <v-text-field v-model="companyName"
                                label="Company Name"
                                :error-messages="$translatedErrorMessages(failedRules,'Company Name')"
                                placeholder="Please enter company's name" solo flat outlined/>
                </ValidationProvider>

                <span>Business Category</span>
                <ValidationProvider name="Business Category" rules="required" v-slot="{ errors, failedRules }">
                  <v-select v-model="businessCategory"
                            :items="data.businessCategory"
                            label="Please select a business category"
                            :error-messages="$translatedErrorMessages(failedRules,'businessCategory')"
                            solo/>
                </ValidationProvider>

                <span>Type of Business</span>
                <ValidationProvider name="Type Of Business" rules="required" v-slot="{ errors, failedRules }">
                  <v-select v-model="typeOfBusiness"
                            :items="data.typeOfBusiness"
                            label="Please select type of business"
                            :error-messages="$translatedErrorMessages(failedRules,'typeOfBusiness')"
                            solo/>
                </ValidationProvider>

                <span>Product Applied</span>
                <ValidationProvider name="Scheme Applied" rules="required" v-slot="{ errors, failedRules }">
                  <v-select v-model="branch"
                            :items="data.schemeDropDownData"
                            label="Please select a product"
                            :error-messages="$translatedErrorMessages(failedRules,'scheme')"
                            solo/>
                </ValidationProvider>

                <span>Financing Amount Requested (RM)</span>
                <ValidationProvider name="Financing Amount Requested (RM)" rules="required|numeric|min_value:10000|max_value:2500000" v-slot="{ errors, failedRules }">
                  <v-text-field v-model="amount"
                                label="Financing Amount Requested (RM)"
                                :error-messages="$translatedErrorMessages(failedRules,'Financing Amount Requested (RM)')"
                                placeholder="Please enter the requested financing amount" solo flat outlined/>
                </ValidationProvider>

                <span>Financing Tenure</span>
                <ValidationProvider name="Financing Tenure" rules="required|numeric|min_value:1|max_value:84" v-slot="{ errors, failedRules }">
                  <v-text-field v-model="financingTenure"
                                label="Financing Tenure"
                                :error-messages="$translatedErrorMessages(failedRules,'Financing Tenure')"
                                placeholder="Please enter the requested financing tenure" solo flat outlined/>
                </ValidationProvider>

                <v-layout  justify-center class="mt-5" >
                  <v-btn  class="mr-4">Reset</v-btn>
                  <v-btn  color="primary">Register</v-btn>
                </v-layout>
              </form>
              </ValidationObserver>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  // eslint-disable-next-line no-unused-vars
  const data = require('../data/sample')
  export default {
    name: 'Registration',
    components: {
      ValidationProvider,
      ValidationObserver
    },
    data: () => ({
        name: '',
        data,
        id: ''
    })
  }
</script>

<style scoped>

</style>
<style>
  .theme--dark.v-label {
    color: rgba(255, 255, 255, 1) !important;
    font-weight: bolder;
  }
  .v-btn__content {
    font-weight: bolder !important;
  }
</style>
